import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { SketchPad } from './modules/sketchPad/sketchpad';
import { Comment } from '@cube3/state/types';
import { isEqual } from '@cube3/state/src/redux/middleware/cube-client-middleware/contract-submit-middleware';
import { isMobile } from 'react-device-detect';
// import { useCanvasBoundingStyles } from '../hooks/useCanvasBoundingStyles';

interface Props {
  annotation?: Comment;
  format?: {
    width: number;
    height: number;
  };
  assetType?: 'video' | 'audio' | 'image';
}
const Annotation = (props: Props) => {
  const { annotation, format, assetType } = props;
  // hooks
  const [canvasElement, setCanvasElement] = useState<HTMLCanvasElement>(null);
  const [sketchPad, setSketchPad] = useState<SketchPad>(null);

  const prevFormat = useRef(null);

  useEffect(() => {
    if (canvasElement) {
      setSketchPad(
        new SketchPad(canvasElement, { values: 'relative', cursor: 'default' })
      );
    }
  }, [canvasElement]);

  const brush = sketchPad?.newBrush();

  //   const canvasStyles = useCanvasBoundingStyles(canvasElement);

  useLayoutEffect(() => {
    // TODO: extend if statement to check if value is an SVG rather than undefined or not...
    if (sketchPad && brush && format) {
      if (annotation?.drawing_svg && format.width && format.height) {
        sketchPad.fromSVG(annotation.drawing_svg);
      }
      // sketchPad.canvas.style.visibility = 'hidden';
      const delay =
        !prevFormat.current || isEqual(prevFormat.current, format) ? 50 : 350;

      const f = setTimeout(() => {
        sketchPad.draw();

        prevFormat.current = format;
        // sketchPad.canvas.style.visibility = 'visible';
      }, delay);
      return () => clearTimeout(f);
    }
  }, [sketchPad, annotation, format]);


  return (
    <div
      style={{
        width: '100%',
        height: isMobile && assetType === 'video' ? 'calc(100% - 136px)' : '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <canvas
        ref={setCanvasElement}
        style={{
          width: `${format?.width}px`,
          height: format && format.height + 'px'
        }}
        width={format && format.width}
        height={format && format.height}
      />
    </div>
  );
};

export default Annotation;
